import { findResourceAll } from "@/api/dsrms/resource"
import { getStepObj } from "../../util/util";

const dsrms = {
    state:{
        statusList:[],
        stepType :{
            STATUS:'STATUS',
            INIT_STATUS: 'INIT_STATUS',
            INVALID_STATUS: 'INVALID_STATUS',
            OPTION: 'OPTION'
        },
        statusType:{
            FORWARD: 'FORWARD',
            BACK: 'BACK'
        }
    },
    actions: {
        setDsrms({commit}){
            // new Promise((resolve) => {
                findResourceAll().then((res) => {
                    const data = JSON.parse(res.data)
                    commit('SET_DSRMS', data)
                    // resolve(data)
                })
            // })
        },
        getSteppings({ state }, resourceType){
            return new Promise((resolve) => {
                let data = []
                for(let status of state.statusList){
                    if(status.resourceType == resourceType) data = status.steppings
                }
                resolve(data);
            })
        },
        getMenuStep({ state }, obj){
            for(let i = 0;i < obj.steppings.length;i++){
                if(obj.steppings[i].code == obj.status){
                    if(obj.steppings[i].statusType == state.statusType.FORWARD){
                        return getStepObj(obj.steppings, obj.steppings[i].nextStep).step
                    }else{
                        return getStepObj(obj.steppings, obj.steppings[i].lastStep).step
                    }
                }
            }
        },
        getMenuName({ state }, obj){
            for(let i = 0;i < obj.steppings.length;i++){
                if(obj.steppings[i].code == obj.status){
                    if(obj.steppings[i].statusType == state.statusType.FORWARD){
                        return getStepObj(obj.steppings, obj.steppings[i].nextStep).name
                    }else{
                        return getStepObj(obj.steppings, obj.steppings[i].lastStep).name
                    }
                }
            }
        },
        getStatusName({ state }, obj){
            return new Promise((resolve) => {
                var data = ''
                for(let i = 0;i < obj.steppings.length;i++){
                    if(obj.steppings[i].code == obj.status){
                        data = obj.steppings[i].name
                    }
                }
                resolve(data)
            })
        }
    },
    mutations: {
        SET_DSRMS: (state, statusList) => {
            state.statusList = statusList
        }
    }
}
export default dsrms